import React, { Component } from 'react'
import { Navbar } from 'react-bootstrap'
import HeaderLinks from './HeaderLinks.jsx'
import eneleRoutes from 'routes/enele.jsx'

class Header extends Component {
    constructor(props) {
        super(props)
        this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this)
    }

    componentDidMount() {
        document.body.classList.toggle('sidebar-mini') //fix small sidebar
    }

    makeBrand() {
        var name
        eneleRoutes.map((prop, key) => {
            if (prop.collapse) {
                prop.views.map((prop, key) => {
                    if (prop.path === this.props.location.pathname) {
                        name = prop.name
                    }
                    return null
                })
            } else {
                if (prop.redirect) {
                    if (prop.path === this.props.location.pathname) {
                        name = prop.name
                    }
                } else {
                    if (prop.path === this.props.location.pathname) {
                        name = prop.name
                    }
                }
            }
            return null
        })
        return name
    }

    // function for responsive that hides/shows the sidebar
    mobileSidebarToggle(e) {
        document.documentElement.classList.toggle('nav-open')
    }
    render() {
        return (
            <Navbar fluid>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a>{this.makeBrand()}</a>
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={this.mobileSidebarToggle} />
                </Navbar.Header>
                {window.innerWidth > 992 ? (<Navbar.Collapse><HeaderLinks /></Navbar.Collapse>) : null}
            </Navbar>
        )
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx